import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type ListSortOrder = 'ascend' | 'descend';

export interface ListSortEntry {
  key: string;
  order: ListSortOrder;
}

export interface DifferenceCheckerSortingState {
  // Active list-view column sorts in click order (oldest first, newest last = primary).
  listSort: ListSortEntry[];
}

const initialState: DifferenceCheckerSortingState = {
  listSort: [],
};

const differenceCheckerSortingSlice = createSlice({
  name: 'differenceCheckerSorting',
  initialState,
  reducers: {
    setListSort(state, action: PayloadAction<ListSortEntry[]>) {
      state.listSort = action.payload;
    },
    clearListSort(state) {
      state.listSort = [];
    },
  },
});

export const { setListSort, clearListSort } =
  differenceCheckerSortingSlice.actions;

export default differenceCheckerSortingSlice.reducer;
